import { DateTime } from "luxon";
import { BookingScheduleInterface } from "../../../../features/Booking-Form/typings/booking.types";
import { checkIfMobileWorking } from "../../ScheduleTodayBookings/schedule-today-bookings-dialog.functions";

/**
 * filter todays schedule which requires check-in
 */
export function filterTodaysSchedule({
  schedules,
  setTodaysCheckin
}: {
  schedules: BookingScheduleInterface[];
  setTodaysCheckin: (t: BookingScheduleInterface[] | undefined) => void;
}) {
  const todays = schedules.filter(
    schedule =>
      DateTime.fromISO(schedule.startDate).toFormat("yyyy MM dd") ===
        DateTime.now().toFormat("yyyy MM dd") &&
      !schedule.checkedIn &&
      !checkIfMobileWorking(schedule) &&
      schedule.checkInPeriod !== -1
  );
  if (todays.length > 0) setTodaysCheckin(todays);
  else setTodaysCheckin(undefined);
}
